/**
 * ortomed-product-info.js
 * Vanilla JS — bez eksternih biblioteka
 * Scope: jedan section element [data-ortomed-product-info]
 */

(function () {
  'use strict';

  function init(sectionEl) {
    if (!sectionEl || sectionEl.dataset.opiInitialized === 'true') return;
    sectionEl.dataset.opiInitialized = 'true';

    var productId = parseInt(sectionEl.dataset.productId, 10);
    var variantData = (window.ortomedVariants && window.ortomedVariants[productId]) || null;
    var priceWrap = sectionEl.querySelector('[data-opi-price]');
    var priceEl = sectionEl.querySelector('[data-opi-price-val]');

    var atcBtn = sectionEl.querySelector('[data-opi-atc]');
    var atcTextEl = atcBtn ? atcBtn.querySelector('[data-atc-text]') : null;
    var defaultAtcText = (atcTextEl ? atcTextEl.textContent.trim() : '') || 'Dodaj u korpu';

    var state = {
      bundle: 1,
      basePrice:
        sectionEl.dataset.basePriceCents ||
        (priceWrap ? priceWrap.dataset.basePrice : '') ||
        (priceEl ? priceEl.getAttribute('data-price-cents') : '') ||
        (priceEl ? priceEl.textContent.trim() : ''),
      baseCompare:
        (priceWrap ? priceWrap.dataset.baseCompare : '') || '',
      defaultAtcText: defaultAtcText,
      mfPrice1: priceWrap ? (priceWrap.dataset.mfPrice1 || '') : '',
      mfCompare1: priceWrap ? (priceWrap.dataset.mfCompare1 || '') : '',
      mfPrice2: priceWrap ? (priceWrap.dataset.mfPrice2 || '') : '',
      mfCompare2: priceWrap ? (priceWrap.dataset.mfCompare2 || '') : '',
      pairDiscountEnabled: priceWrap ? isTruthySetting(priceWrap.dataset.discountEnabled) : false,
      pairDiscountValue: priceWrap ? normalizeMfPrice(priceWrap.dataset.discountValue || 0) : 0,
      giftedPairEnabled: priceWrap ? isTruthySetting(priceWrap.dataset.giftedPairEnabled) : false,
      giftedPairLabel: priceWrap ? (priceWrap.dataset.giftedPairLabel || '1+1 gratis') : '1+1 gratis',
      pairs: {
        1: { color: null, size: null, variantId: null },
        2: { color: null, size: null, variantId: null }
      }
    };

    if (state.giftedPairEnabled) {
      state.bundle = 2;
    }

    if (priceEl && state.basePrice) {
      priceEl.dataset.basePrice = state.basePrice;
      updatePrice(sectionEl, state.basePrice);
    }

    initGallery(sectionEl);
    initDesktopGalleryArrows(sectionEl);
    initMobileCarousel(sectionEl);
    initBundleSelector(sectionEl, state, variantData);
    
    renderGiftProducts(sectionEl, 'therapy');

    [1, 2].forEach(function (pairIdx) {
      initColorPicker(sectionEl, pairIdx, state, variantData);
      initSizePicker(sectionEl, pairIdx, state, variantData);
    });

    initForm(sectionEl, state);
    initUpsell(sectionEl);
    initSizeGuide(sectionEl);
    initAccordions(sectionEl);
    initInitialVariant(sectionEl, state, variantData);
    refreshPrice(sectionEl, state, variantData);
    updateAtcBtnText(sectionEl, state);
  }

  function initInitialVariant(sectionEl, state, variantData) {
    if (!variantData || !variantData.variants || !variantData.variants.length) return;

    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    var variant = null;

    if (variantId) {
      variant = variantData.variants.find(function (v) {
        return String(v.id) === String(variantId) && v.available;
      }) || null;
    }

    if (!variant) {
      variant = findFirstAvailableVariant(variantData);
    }

    if (!variant) return;

    /*
     * Selecting the color first unlocks the available size buttons,
     * after which selectSize can preselect the starting size.
     */
    selectVariantForPair(sectionEl, 1, variant, state, variantData);

    /*
     * Pair 2 is already visible for gifted-pair products, so it also
     * needs an initial color and size. Otherwise its sizes stay disabled.
     */
    if (state.giftedPairEnabled) {
      selectVariantForPair(sectionEl, 2, variant, state, variantData);
    }
  }

  function findFirstAvailableVariant(variantData) {
    if (!variantData || !variantData.variants || !variantData.variants.length) return null;

    return variantData.variants.find(function (variant) {
      return variant.available;
    }) || null;
  }

  function selectVariantForPair(sectionEl, pairIdx, variant, state, variantData) {
    if (!variant || !variant.options) return;

    var color = variant.options[variantData.bojaIndex];
    var size  = variant.options[variantData.velicinaIndex];

    if (color) selectColor(sectionEl, pairIdx, color, state, variantData);
    if (size)  selectSize(sectionEl, pairIdx, size, state, variantData);
  }

  // ─────────────────────────────────────────────
  // GALLERY
  // ─────────────────────────────────────────────
  function initGallery(sectionEl) {
    var thumbs = sectionEl.querySelectorAll('[data-thumb]');
    var mainImgs = sectionEl.querySelectorAll('[data-main]');
    if (!thumbs.length || !mainImgs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = parseInt(thumb.dataset.thumb, 10);
        if (isNaN(idx)) return;

        /*
          Thumbnails stay visible at all times, but desktop/mobile images
          may still be filtered by selected color. When the customer clicks
          a thumbnail, allow that exact image to display.
        */
        forceGalleryIndexVisible(sectionEl, idx);

        scrollGalleryToIndex(sectionEl, idx);
      });
    });
  }

  function initDesktopGalleryArrows(sectionEl) {
    var prevBtn = sectionEl.querySelector('[data-gallery-prev]');
    var nextBtn = sectionEl.querySelector('[data-gallery-next]');
    if (!prevBtn && !nextBtn) return;

    function getGalleryIndexes() {
      return Array.from(sectionEl.querySelectorAll('[data-main]'))
        .map(function (img, fallbackIndex) {
          var idx = parseInt(img.dataset.main, 10);
          return !isNaN(idx) ? idx : fallbackIndex;
        })
        .filter(function (idx) {
          return !isNaN(idx);
        })
        .sort(function (a, b) {
          return a - b;
        });
    }

    function getActiveGalleryIndex() {
      var activeMain = sectionEl.querySelector('[data-main].is-active');

      if (activeMain) {
        var activeMainIdx = parseInt(activeMain.dataset.main, 10);
        if (!isNaN(activeMainIdx)) return activeMainIdx;
      }

      var activeThumb = sectionEl.querySelector('[data-thumb].is-active');

      if (activeThumb) {
        var activeThumbIdx = parseInt(activeThumb.dataset.thumb, 10);
        if (!isNaN(activeThumbIdx)) return activeThumbIdx;
      }

      return 0;
    }

    function navigate(dir) {
      var indexes = getGalleryIndexes();
      if (!indexes.length) return;

      var activeIdx = getActiveGalleryIndex();
      var activePosition = indexes.indexOf(activeIdx);

      if (activePosition === -1) {
        activePosition = 0;
      }

      var nextPosition = dir === 'prev'
        ? (activePosition - 1 + indexes.length) % indexes.length
        : (activePosition + 1) % indexes.length;

      var nextIdx = indexes[nextPosition];

      /*
        Important:
        The selected image may have been hidden by the color filter.
        Since arrows should now move through all thumbnails/images,
        we unlock the target image before activating it.
      */
      forceGalleryIndexVisible(sectionEl, nextIdx);

      scrollGalleryToIndex(sectionEl, nextIdx);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        navigate('prev');
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        navigate('next');
      });
    }
  }

  function forceGalleryIndexVisible(sectionEl, idx) {
    var mainImg = sectionEl.querySelector('[data-main="' + idx + '"]');
    var mobSlide = sectionEl.querySelector('[data-mob-slide="' + idx + '"]');

    if (mainImg) {
      mainImg.classList.remove('opi-filtered-out');
    }

    if (mobSlide) {
      mobSlide.classList.remove('opi-filtered-out');
    }
  }

  function activateSlide(thumbs, mainImgs, idx) {
    idx = parseInt(idx, 10);
    if (isNaN(idx)) return;

    thumbs.forEach(function (thumb, fallbackIndex) {
      var thumbIdx = parseInt(thumb.dataset.thumb, 10);
      var isActive = !isNaN(thumbIdx)
        ? thumbIdx === idx
        : fallbackIndex === idx;

      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    mainImgs.forEach(function (img, fallbackIndex) {
      var mainIdx = parseInt(img.dataset.main, 10);
      var isActive = !isNaN(mainIdx)
        ? mainIdx === idx
        : fallbackIndex === idx;

      img.classList.toggle('is-active', isActive);
    });
  }

  function scrollThumbIntoView(thumbEl) {
    var container = thumbEl.parentElement;
    if (!container) return;
    var left = thumbEl.offsetLeft;
    var width = thumbEl.offsetWidth;
    var cLeft = container.scrollLeft;
    var cWidth = container.clientWidth;
    if (left < cLeft) {
      container.scrollLeft = left - 4;
    } else if (left + width > cLeft + cWidth) {
      container.scrollLeft = left + width - cWidth + 4;
    }
  }

  function scrollGalleryToIndex(sectionEl, idx) {
    idx = parseInt(idx, 10);
    if (isNaN(idx)) return;

    var thumbs = Array.from(sectionEl.querySelectorAll('[data-thumb]'));
    var mainImgs = Array.from(sectionEl.querySelectorAll('[data-main]'));

    if (!thumbs.length || !mainImgs.length) return;

    var targetMain = mainImgs.find(function (img, fallbackIndex) {
      var mainIdx = parseInt(img.dataset.main, 10);
      return !isNaN(mainIdx) ? mainIdx === idx : fallbackIndex === idx;
    });

    if (!targetMain) return;

    activateSlide(thumbs, mainImgs, idx);

    var targetThumb = thumbs.find(function (thumb, fallbackIndex) {
      var thumbIdx = parseInt(thumb.dataset.thumb, 10);
      return !isNaN(thumbIdx) ? thumbIdx === idx : fallbackIndex === idx;
    });

    if (targetThumb) {
      scrollThumbIntoView(targetThumb);
    }

    var carouselEl = sectionEl.querySelector('[data-mob-carousel]');
    if (carouselEl && typeof carouselEl._goToRawIndex === 'function') {
      carouselEl._goToRawIndex(idx);
    }
  }

  function findGalleryIndexByMediaId(sectionEl, mediaId) {
    if (!mediaId) return -1;

    var mainImgs = Array.from(sectionEl.querySelectorAll('[data-main]'));
    var idx = mainImgs.findIndex(function (img) {
      return String(img.dataset.mediaId) === String(mediaId);
    });

    if (idx !== -1) return idx;

    var thumbs = Array.from(sectionEl.querySelectorAll('[data-thumb]'));
    return thumbs.findIndex(function (thumb) {
      return String(thumb.dataset.mediaId) === String(mediaId);
    });
  }

  function findGalleryIndexByColor(sectionEl, colorName) {
    if (!colorName) return -1;

    var lc = colorName.toLowerCase();
    var mainImgs = Array.from(sectionEl.querySelectorAll('[data-main]'));
    var thumbs = Array.from(sectionEl.querySelectorAll('[data-thumb]'));

    for (var i = 0; i < mainImgs.length; i++) {
      var mainAlt = (mainImgs[i].dataset.alt || '').toLowerCase();
      if (mainAlt.indexOf(lc) !== -1) return i;
    }

    for (var j = 0; j < thumbs.length; j++) {
      var thumbAlt = (thumbs[j].dataset.alt || '').toLowerCase();
      if (thumbAlt.indexOf(lc) !== -1) return j;
    }

    return -1;
  }

  function updateVariantImage(sectionEl, variant) {
    if (!variant) return;

    var targetIndex = -1;

    if (variant.featuredMediaId) {
      targetIndex = findGalleryIndexByMediaId(sectionEl, variant.featuredMediaId);
    }

    if (targetIndex === -1 && variant.options && variant.options.length) {
      var fallbackColor = variant.options[0];
      targetIndex = findGalleryIndexByColor(sectionEl, fallbackColor);
    }

    if (targetIndex !== -1) {
      scrollGalleryToIndex(sectionEl, targetIndex);
    }
  }

  function filterGalleryByColor(sectionEl, color) {
    var mainImgs = Array.from(sectionEl.querySelectorAll('[data-main]'));
    var thumbs   = Array.from(sectionEl.querySelectorAll('[data-thumb]'));
    var mobSlides = Array.from(sectionEl.querySelectorAll('[data-mob-slide]'));

    // No color selected — show everything
    if (!color) {
      mainImgs.forEach(function (el) { el.classList.remove('opi-filtered-out'); });
      thumbs.forEach(function (el)   { el.classList.remove('opi-filtered-out'); });
      mobSlides.forEach(function (el) { el.classList.remove('opi-filtered-out'); });
      syncCarousel(sectionEl, mobSlides);
      return;
    }

    var lc = color.toLowerCase();

    // Collect media IDs linked to this color via Shopify variant data
    var productId   = parseInt(sectionEl.dataset.productId, 10);
    var variantData = (window.ortomedVariants && window.ortomedVariants[productId]) || null;
    var colorMediaIds = {};

    if (variantData) {
      var bojaIdx = variantData.bojaIndex;
      variantData.variants.forEach(function (v) {
        if (v.options && v.options[bojaIdx] &&
            v.options[bojaIdx].toLowerCase() === lc &&
            v.featuredMediaId) {
          colorMediaIds[String(v.featuredMediaId)] = true;
        }
      });
    }

    // Normalize hyphens/underscores/spaces so "crno-roza" matches "crno roza" and vice versa
    var lcNorm = lc.replace(/[-_ ]+/g, ' ').trim();

    function matches(el) {
      var mediaId = String(el.dataset.mediaId || '');
      if (colorMediaIds[mediaId]) return true;
      var altLc   = (el.dataset.alt || '').toLowerCase();
      if (!altLc) return false;
      if (altLc.indexOf(lc) !== -1) return true;
      var altNorm = altLc.replace(/[-_ ]+/g, ' ').trim();
      if (altNorm.indexOf(lcNorm) !== -1) return true;
      return false;
    }

    // Apply strict filtering using CSS class (defeats display:block !important on thumbs)
    function applyFilter(els) {
      var matched = els.filter(matches);
      if (matched.length > 0) {
        els.forEach(function (el) {
          el.classList.toggle('opi-filtered-out', !matches(el));
        });
      } else if (Object.keys(colorMediaIds).length > 0) {
        // Nothing matched alt-text but we have featured media IDs — show those at minimum
        els.forEach(function (el) {
          var keep = !!colorMediaIds[String(el.dataset.mediaId || '')];
          el.classList.toggle('opi-filtered-out', !keep);
        });
      }
      // If truly nothing matches and no media IDs — leave all visible (can't hide everything)
    }

    applyFilter(mainImgs);
    // applyFilter(thumbs);
    applyFilter(mobSlides);

    // Activate first visible desktop image
    var firstVisible = mainImgs.findIndex(function (el) {
      return !el.classList.contains('opi-filtered-out') && el.style.display !== 'none';
    });
    if (firstVisible !== -1) {
      activateSlide(thumbs, mainImgs, firstVisible);
      if (thumbs[firstVisible]) scrollThumbIntoView(thumbs[firstVisible]);
    }

    syncCarousel(sectionEl, mobSlides);
  }

  function syncCarousel(sectionEl, mobSlides) {
    var carouselEl = sectionEl.querySelector('[data-mob-carousel]');
    if (!carouselEl) return;
    if (typeof carouselEl._getVisibleSlides === 'function' &&
        typeof carouselEl._syncDots === 'function') {
      carouselEl._syncDots(carouselEl._getVisibleSlides());
    }
    if (typeof carouselEl._goToRawIndex === 'function') {
      var slides = mobSlides || Array.from(sectionEl.querySelectorAll('[data-mob-slide]'));
      var first = slides.findIndex(function (s) {
        return !s.classList.contains('opi-filtered-out') && s.style.display !== 'none';
      });
      if (first !== -1) carouselEl._goToRawIndex(first);
    }
  }

  function updateAtcBtnText(sectionEl, state) {
    var btnTextEl = sectionEl.querySelector('[data-atc-text]');
    if (!btnTextEl) return;

    var form = sectionEl.querySelector('[data-opi-form]');
    if (form && form.hasAttribute('data-simple-atc')) return;

    var p1 = state.pairs[1];
    var p2 = state.pairs[2];
    var text = state.defaultAtcText;

    if (state.bundle === 1) {
      if (!p1.color) {
        text = 'Izaberite boju';
      } else if (!p1.size) {
        text = 'Izaberite veličinu';
      }
    } else {
      if (!p1.color || !p2.color) {
        text = 'Izaberite boju';
      } else if (!p1.size || !p2.size) {
        text = 'Izaberite veličinu';
      }
    }

    btnTextEl.textContent = text;
  }

  // ─────────────────────────────────────────────
  // MOBILE CAROUSEL
  // ─────────────────────────────────────────────
  function initMobileCarousel(sectionEl) {
    var carouselEl = sectionEl.querySelector('[data-mob-carousel]');
    if (!carouselEl) return;

    var track = carouselEl.querySelector('[data-mob-track]');
    var prevBtn = carouselEl.querySelector('[data-mob-prev]');
    var nextBtn = carouselEl.querySelector('[data-mob-next]');
    var dotsWrap = carouselEl.querySelector('[data-mob-dots]');
    if (!track) return;

    var slides = Array.from(track.querySelectorAll('[data-mob-slide]'));
    var current = 0;
    var scrollRaf = null;

    function getRawIndex(slide, fallbackIndex) {
      if (!slide) return fallbackIndex || 0;

      var raw = parseInt(slide.dataset.mobSlide, 10);
      return !isNaN(raw) ? raw : fallbackIndex;
    }

    function getVisibleSlides() {
      return slides.filter(function (slide) {
        return slide.style.display !== 'none';
      });
    }

    function clampIndex(idx, list) {
      if (!list || !list.length) return 0;
      return Math.max(0, Math.min(idx, list.length - 1));
    }

    function syncDots(visibleSlides) {
      if (!dotsWrap) return;

      visibleSlides = visibleSlides || getVisibleSlides();

      var dots = dotsWrap.querySelectorAll('[data-dot]');
      var activeSlide = visibleSlides[current] || slides[0];
      var activeThumbnail = null;

      var activeRawIndex = activeSlide
        ? getRawIndex(activeSlide, current)
        : current;

      dots.forEach(function (dot) {
        var dotIdx = parseInt(dot.dataset.dot, 10);
        if (isNaN(dotIdx)) return;

        dot.style.display = '';

        var isActive = dotIdx === activeRawIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isActive) {
          activeThumbnail = dot;
        }
      });

      if (activeThumbnail) {
        scrollMobileThumbnailIntoView(dotsWrap, activeThumbnail);
      }
    }

    function scrollMobileThumbnailIntoView(container, thumbnail) {
      var containerRect = container.getBoundingClientRect();
      var thumbnailRect = thumbnail.getBoundingClientRect();
      var leftDifference = thumbnailRect.left - containerRect.left;
      var rightDifference = thumbnailRect.right - containerRect.right;

      if (leftDifference < 0) {
        container.scrollBy({
          left: leftDifference - 4,
          behavior: 'smooth'
        });
      } else if (rightDifference > 0) {
        container.scrollBy({
          left: rightDifference + 4,
          behavior: 'smooth'
        });
      }
    }

    function getClosestVisibleIndex() {
      var visibleSlides = getVisibleSlides();
      if (!visibleSlides.length) return 0;

      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var dist = Infinity;

      visibleSlides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var d = Math.abs(slideCenter - trackCenter);

        if (d < dist) {
          dist = d;
          closest = i;
        }
      });

      return closest;
    }

    function updateCurrentFromScroll() {
      var visibleSlides = getVisibleSlides();
      if (!visibleSlides.length) return;

      current = getClosestVisibleIndex();
      syncDots(visibleSlides);
    }

    function goToVisibleIndex(idx, behavior) {
      var visibleSlides = getVisibleSlides();
      if (!visibleSlides.length) return;

      idx = clampIndex(idx, visibleSlides);
      current = idx;

      var target = visibleSlides[idx];
      if (!target) return;

      track.scrollTo({
        left: target.offsetLeft,
        behavior: behavior || 'smooth'
      });

      syncDots(visibleSlides);
    }

    function goToRawIndex(rawIndex, behavior) {
      if (!slides.length) return;

      rawIndex = parseInt(rawIndex, 10);
      if (isNaN(rawIndex)) return;

      var target = slides.find(function (slide, fallbackIndex) {
        return getRawIndex(slide, fallbackIndex) === rawIndex;
      });

      if (!target) return;

      target.classList.remove('opi-filtered-out');

      var visibleSlides = getVisibleSlides();
      var visibleIndex = visibleSlides.indexOf(target);

      if (visibleIndex === -1) return;

      current = visibleIndex;

      track.scrollTo({
        left: target.offsetLeft,
        behavior: behavior || 'smooth'
      });

      syncDots(visibleSlides);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        updateCurrentFromScroll();
        goToVisibleIndex(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        updateCurrentFromScroll();
        goToVisibleIndex(current + 1);
      });
    }

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-dot]');
        if (!dot) return;

        var requested = parseInt(dot.dataset.dot, 10);
        if (isNaN(requested)) return;

        goToRawIndex(requested);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) {
          window.cancelAnimationFrame(scrollRaf);
        }

        scrollRaf = window.requestAnimationFrame(function () {
          updateCurrentFromScroll();
          scrollRaf = null;
        });
      },
      { passive: true }
    );

    carouselEl._slides = slides;
    carouselEl._goTo = goToVisibleIndex;
    carouselEl._goToRawIndex = goToRawIndex;
    carouselEl._syncDots = syncDots;
    carouselEl._getVisibleSlides = getVisibleSlides;

    updateCurrentFromScroll();
    syncDots(getVisibleSlides());
  }

  // ─────────────────────────────────────────────
  // BUNDLE
  // ─────────────────────────────────────────────
  function initBundleSelector(sectionEl, state, variantData) {
    var radios = sectionEl.querySelectorAll('[data-bundle-radio]');
    var cards = sectionEl.querySelectorAll('[data-bundle-card]');

    if (!radios.length) return;

    if (state.giftedPairEnabled) {
      state.bundle = 2;

      /*
       * Explicitly synchronize the rendered radio with the JS state.
       */
      radios.forEach(function (radio) {
        radio.checked = parseInt(radio.value, 10) === 2;
      });
    } else {
      var checkedRadio = sectionEl.querySelector('[data-bundle-radio]:checked');
      var checkedBundle = checkedRadio
        ? parseInt(checkedRadio.value, 10)
        : NaN;

      if (!isNaN(checkedBundle)) {
        state.bundle = checkedBundle;
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var val = state.giftedPairEnabled
          ? 2
          : parseInt(radio.value, 10);

        if (state.giftedPairEnabled) {
          radios.forEach(function (bundleRadio) {
            bundleRadio.checked = parseInt(bundleRadio.value, 10) === 2;
          });
        }

        state.bundle = val;

        updateBundleUI(sectionEl, cards, val);

        if (val >= 2 && !state.pairs[2].color) {
          var seedVariant = getVariantById(variantData, state.pairs[1].variantId) || findFirstAvailableVariant(variantData);
          if (seedVariant) {
            selectVariantForPair(sectionEl, 2, seedVariant, state, variantData);
          }
        }

        refreshPrice(sectionEl, state, variantData);
        updateAtcBtnText(sectionEl, state);
      });
    });

    updateBundleUI(sectionEl, cards, state.bundle);
  }

  function updateBundleUI(sectionEl, cards, bundle) {
    cards.forEach(function (card) {
      var cardBundle = parseInt(card.dataset.bundleCard, 10);
      card.classList.toggle('is-active', cardBundle === bundle);
    });

    var pairsEl = sectionEl.querySelector('[data-pairs]');
    if (pairsEl) {
      pairsEl.classList.toggle('opi-pairs--multi', bundle >= 2);
    }

    var pair2 = sectionEl.querySelector('[data-pair-picker="2"]');
    if (pair2) {
      if (bundle < 2) {
        pair2.classList.add('is-hidden');
        pair2.setAttribute('aria-hidden', 'true');
        pair2.classList.remove('opi-animating-in');

        hideGiftProducts(sectionEl, 2);
      } else {
        pair2.classList.remove('is-hidden');
        pair2.setAttribute('aria-hidden', 'false');
        pair2.classList.remove('opi-animating-in');
        void pair2.offsetWidth;
        pair2.classList.add('opi-animating-in');

        renderGiftProducts(sectionEl, 2);
      }
    }
  }

  // Gift product rendering
  function renderGiftProducts(sectionEl, pairIdx) {
    var jsonEl = sectionEl.querySelector('[data-gift-products-json="' + pairIdx + '"]');
    var wrapper = sectionEl.querySelector('[data-gift-products="' + pairIdx + '"]');
    var grid = sectionEl.querySelector('[data-gift-products-grid="' + pairIdx + '"]');

    if (!jsonEl || !wrapper || !grid) return;

    var gifts = [];

    try {
      gifts = JSON.parse(jsonEl.textContent || '[]');
    } catch (err) {
      gifts = [];
    }

    grid.innerHTML = '';

    if (!gifts.length) {
      hideGiftProducts(sectionEl, pairIdx);
      return;
    }

    gifts.forEach(function (gift) {
      var giftEl = document.createElement('div');
      giftEl.className = 'opi-gift-product';
      giftEl.setAttribute('data-gift-product', '');
      giftEl.dataset.productId = gift.id || '';
      giftEl.dataset.productHandle = gift.handle || '';

      if (gift.image) {
        var imageWrap = document.createElement('div');
        imageWrap.className = 'opi-gift-product__image-wrap';

        var img = document.createElement('img');
        img.src = gift.image;
        img.alt = gift.title || '';
        img.className = 'opi-gift-product__image';
        img.loading = 'lazy';

        imageWrap.appendChild(img);
        giftEl.appendChild(imageWrap);
      }

      var content = document.createElement('div');
      content.className = 'opi-gift-product__content';

      var title = document.createElement('span');
      title.className = 'opi-gift-product__title';
      title.textContent = gift.title || '';

      var price = document.createElement('div');
      price.className = 'opi-gift-product__price';
      price.innerHTML = gift.price || '';

      content.appendChild(title);
      content.appendChild(price);
      giftEl.appendChild(content);

      grid.appendChild(giftEl);
    });

    wrapper.classList.remove('is-hidden');
    wrapper.setAttribute('aria-hidden', 'false');
  }

  function hideGiftProducts(sectionEl, pairIdx) {
    var wrapper = sectionEl.querySelector('[data-gift-products="' + pairIdx + '"]');
    var grid = sectionEl.querySelector('[data-gift-products-grid="' + pairIdx + '"]');

    if (wrapper) {
      wrapper.classList.add('is-hidden');
      wrapper.setAttribute('aria-hidden', 'true');
    }

    if (grid) {
      grid.innerHTML = '';
    }
  }

  // ─────────────────────────────────────────────
  // COLOR PICKER
  // ─────────────────────────────────────────────
  function initColorPicker(sectionEl, pairIdx, state, variantData) {
    var swatchesEl = sectionEl.querySelector('[data-swatches="' + pairIdx + '"]');
    if (!swatchesEl) return;

    swatchesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-color]');
      if (!btn) return;

      var color = btn.dataset.color;
      selectColor(sectionEl, pairIdx, color, state, variantData);
    });
  }

  function selectColor(sectionEl, pairIdx, color, state, variantData) {
    var previousSize = state.pairs[pairIdx].size;

    state.pairs[pairIdx].color = color;
    state.pairs[pairIdx].variantId = null;

    var swatchesEl = sectionEl.querySelector('[data-swatches="' + pairIdx + '"]');
    if (swatchesEl) {
      swatchesEl.querySelectorAll('[data-color]').forEach(function (btn) {
        var isActive = btn.dataset.color === color;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    var selectedEl = sectionEl.querySelector('[data-color-selected="' + pairIdx + '"]');
    if (selectedEl) {
      selectedEl.textContent = color;
      selectedEl.classList.remove('is-hidden');
      selectedEl.removeAttribute('aria-hidden');
    }

    updateSizeAvailability(sectionEl, pairIdx, color, state, variantData);

    filterGalleryByColor(sectionEl, color);

    var colorVariant = findFirstVariantByColor(variantData, color);
    if (colorVariant) {
      updateVariantImage(sectionEl, colorVariant);
    }

    if (previousSize && isSizeAvailableForColor(color, previousSize, variantData)) {
      selectSize(sectionEl, pairIdx, previousSize, state, variantData);
      updateAtcBtnText(sectionEl, state);
      return;
    }

    state.pairs[pairIdx].size = null;
    state.pairs[pairIdx].variantId = null;

    clearSizeSelection(sectionEl, pairIdx);
    updatePairInput(sectionEl, pairIdx, null);
    updatePairStatus(sectionEl, pairIdx, color, null);
    refreshPrice(sectionEl, state, variantData);
    updateAtcBtnText(sectionEl, state);
  }

  function findFirstVariantByColor(variantData, color) {
    if (!variantData || !color) return null;

    var bojaIdx = variantData.bojaIndex;

    return (
      variantData.variants.find(function (variant) {
        return (
          variant.options &&
          variant.options[bojaIdx] === color &&
          variant.featuredMediaId
        );
      }) ||
      variantData.variants.find(function (variant) {
        return variant.options && variant.options[bojaIdx] === color;
      }) ||
      null
    );
  }

  function isSizeAvailableForColor(color, size, variantData) {
    if (!variantData || !color || !size) return false;

    var bojaIdx = variantData.bojaIndex;
    var velicinaIdx = variantData.velicinaIndex;

    return variantData.variants.some(function (variant) {
      return (
        variant.available &&
        variant.options &&
        variant.options[bojaIdx] === color &&
        variant.options[velicinaIdx] === size
      );
    });
  }

  // ─────────────────────────────────────────────
  // SIZE PICKER
  // ─────────────────────────────────────────────
  function initSizePicker(sectionEl, pairIdx, state, variantData) {
    var sizesEl = sectionEl.querySelector('[data-sizes="' + pairIdx + '"]');
    if (!sizesEl) return;

    sizesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size]');
      if (!btn || btn.classList.contains('is-disabled') || btn.disabled) return;

      var size = btn.dataset.size;
      selectSize(sectionEl, pairIdx, size, state, variantData);
    });
  }

  function updateSizeAvailability(sectionEl, pairIdx, color, state, variantData) {
    var sizesEl = sectionEl.querySelector('[data-sizes="' + pairIdx + '"]');
    var lockMsg = sectionEl.querySelector('[data-lock-msg="' + pairIdx + '"]');
    if (!sizesEl) return;

    var btns = sizesEl.querySelectorAll('[data-size]');
    sizesEl.classList.remove('is-locked');
    if (lockMsg) lockMsg.style.display = 'none';

    if (!variantData || !color || typeof variantData.bojaIndex === 'undefined' || typeof variantData.velicinaIndex === 'undefined') {
      btns.forEach(function (btn) {
        btn.classList.remove('is-disabled');
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
      });
      return;
    }

    var bojaIdx = variantData.bojaIndex;
    var velicinaIdx = variantData.velicinaIndex;

    btns.forEach(function (btn) {
      var size = btn.dataset.size;
      var available = variantData.variants.some(function (variant) {
        return (
          variant.available &&
          variant.options &&
          variant.options[bojaIdx] === color &&
          variant.options[velicinaIdx] === size
        );
      });

      btn.classList.toggle('is-disabled', !available);
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', !available ? 'true' : 'false');
    });
  }

  function applySizeBtnStyle(btn, isActive, sectionEl) {
    if (isActive) {
      var accent = getComputedStyle(sectionEl).getPropertyValue('--opi-accent-color').trim() || '#152447';
      var ring   = getComputedStyle(sectionEl).getPropertyValue('--opi-active-ring').trim()   || '#c8dcde';
      btn.style.setProperty('background-color', accent, 'important');
      btn.style.setProperty('border-color',     accent, 'important');
      btn.style.setProperty('color',            '#ffffff', 'important');
      btn.style.setProperty('box-shadow', '0 0 0 2px #fff, 0 0 0 5px ' + ring, 'important');
    } else {
      btn.style.removeProperty('background-color');
      btn.style.removeProperty('border-color');
      btn.style.removeProperty('color');
      btn.style.removeProperty('box-shadow');
    }
  }

  function clearSizeSelection(sectionEl, pairIdx) {
    var sizesEl = sectionEl.querySelector('[data-sizes="' + pairIdx + '"]');
    if (!sizesEl) return;

    sizesEl.querySelectorAll('[data-size]').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-checked', 'false');
      applySizeBtnStyle(btn, false, sectionEl);
    });

    var sizeSelectedEl = sectionEl.querySelector('[data-size-selected="' + pairIdx + '"]');
    if (sizeSelectedEl) {
      sizeSelectedEl.textContent = '';
      sizeSelectedEl.classList.add('is-hidden');
    }
  }

  function selectSize(sectionEl, pairIdx, size, state, variantData) {
    state.pairs[pairIdx].size = size;

    var sizesEl = sectionEl.querySelector('[data-sizes="' + pairIdx + '"]');
    if (sizesEl) {
      sizesEl.querySelectorAll('[data-size]').forEach(function (btn) {
        var isActive = btn.dataset.size === size;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
        applySizeBtnStyle(btn, isActive, sectionEl);
      });
    }

    var variantId = findVariantId(state.pairs[pairIdx].color, size, variantData);
    state.pairs[pairIdx].variantId = variantId;
    updatePairInput(sectionEl, pairIdx, variantId);
    updatePairStatus(sectionEl, pairIdx, state.pairs[pairIdx].color, size);

    var sizeSelectedEl = sectionEl.querySelector('[data-size-selected="' + pairIdx + '"]');
    if (sizeSelectedEl) {
      sizeSelectedEl.textContent = size;
      sizeSelectedEl.classList.remove('is-hidden');
      sizeSelectedEl.removeAttribute('aria-hidden');
    }

    if (!variantId || !variantData) {
      refreshPrice(sectionEl, state, variantData);
      return;
    }

    var variant = variantData.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (variant) {
      updateVariantImage(sectionEl, variant);
    }

    refreshPrice(sectionEl, state, variantData);
    updateAtcBtnText(sectionEl, state);
  }

  function findVariantId(color, size, variantData) {
    if (!variantData || !color || !size) return null;

    var bojaIdx = variantData.bojaIndex;
    var velicinaIdx = variantData.velicinaIndex;

    var variant = variantData.variants.find(function (item) {
      return (
        item.options &&
        item.options[bojaIdx] === color &&
        item.options[velicinaIdx] === size
      );
    });

    return variant ? variant.id : null;
  }

  function getVariantById(variantData, variantId) {
    if (!variantData || !variantId) return null;

    return variantData.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function updatePairInput(sectionEl, pairIdx, variantId) {
    var input = sectionEl.querySelector('[data-pair-input="' + pairIdx + '"]');
    if (input) input.value = variantId || '';
  }

  function updatePairStatus(sectionEl, pairIdx, color, size) {
    var statusEl = sectionEl.querySelector('[data-pair-status="' + pairIdx + '"]');
    if (!statusEl) return;

    if (color && size) {
      statusEl.textContent = color + ', ' + size;
    } else if (color) {
      statusEl.textContent = color;
    } else {
      statusEl.textContent = '';
    }
  }

  // ─────────────────────────────────────────────
  // PRICE
  // ─────────────────────────────────────────────
  function refreshPrice(sectionEl, state, variantData) {
    var pair1Variant = getVariantById(variantData, state.pairs[1].variantId);
    var pair2Variant = getVariantById(variantData, state.pairs[2].variantId);

    var basePrice = normalizeMoneyValue(state.basePrice);
    var baseCompare = state.baseCompare ? normalizeMoneyValue(state.baseCompare) : 0;

    function variantPrice(v) {
      return v ? normalizeMoneyValue(v.price) : basePrice;
    }

    function variantCompare(v) {
      if (v && v.compareAtPrice != null) return normalizeMoneyValue(v.compareAtPrice);
      return baseCompare;
    }

    var pair1Price = variantPrice(pair1Variant);
    var pair1Compare = variantCompare(pair1Variant);
    var pair2Price = variantPrice(pair2Variant);
    var pair2Compare = variantCompare(pair2Variant);

    var finalPrice1 = state.mfPrice1 ? normalizeMfPrice(state.mfPrice1) : pair1Price;
    var finalCompare1 = state.mfCompare1 ? normalizeMfPrice(state.mfCompare1) : pair1Compare;

    var pair2BasePrice = state.mfPrice2 ? normalizeMfPrice(state.mfPrice2) : pair1Price + pair2Price;

    var pair2RegularTotal = state.mfPrice1
      ? finalPrice1 * 2
      : pair1Price + pair2Price;

    var finalCompare2 = state.giftedPairEnabled
      ? (state.mfCompare2 ? normalizeMfPrice(state.mfCompare2) : pair2RegularTotal)
      : (state.mfCompare2 ? normalizeMfPrice(state.mfCompare2) : pair1Compare + pair2Compare);

    var pairDiscount = (
      !state.giftedPairEnabled &&
      state.pairDiscountEnabled &&
      state.pairDiscountValue > 0
    )
      ? state.pairDiscountValue
      : 0;

    var finalPrice2 = state.giftedPairEnabled
      ? finalPrice1
      : Math.max(0, pair2BasePrice - pairDiscount);

    updateComparedDiscountBadge(
      sectionEl,
      state,
      finalPrice1,
      finalCompare1,
      finalPrice2,
      finalCompare2,
      pairDiscount
    );

    if (state.bundle === 1) {
      updatePrice(sectionEl, finalPrice1, finalCompare1);
      return;
    }

    updatePrice(
      sectionEl,
      finalPrice2,
      finalCompare2,
      state.giftedPairEnabled ? state.giftedPairLabel : ''
    );
  }

  function getDiscountPercent(priceValue, compareValue) {
    priceValue = normalizeMoneyValue(priceValue);
    compareValue = normalizeMoneyValue(compareValue);

    if (!compareValue || !priceValue || compareValue <= priceValue) return 0;

    return Math.round((compareValue - priceValue) * 100 / compareValue);
  }

  function updateComparedDiscountBadge(sectionEl, state, onePairPrice, onePairCompare, twoPairPrice, twoPairCompare, pairDiscount) {
    var badgeEl = sectionEl.querySelector('[data-compared-discount-badge]');
    var cardEl = sectionEl.querySelector('#compared-discount-element');

    if (!badgeEl) return;

    if (state.giftedPairEnabled) {
      badgeEl.textContent = state.giftedPairLabel || '1+1 gratis';
      badgeEl.hidden = false;

      if (cardEl) {
        cardEl.classList.add('has-compared-discount');
      }

      return;
    }

    var onePairDiscountPct = getDiscountPercent(onePairPrice, onePairCompare);
    var twoPairDiscountPct = getDiscountPercent(twoPairPrice, twoPairCompare);
    var additionalDiscountPct = Math.max(0, twoPairDiscountPct - onePairDiscountPct);

    var shouldShow = (
      state.pairDiscountEnabled &&
      pairDiscount > 0 &&
      additionalDiscountPct > 0
    );

    if (!shouldShow) {
      badgeEl.textContent = '';
      badgeEl.hidden = true;

      if (cardEl) {
        cardEl.classList.remove('has-compared-discount');
      }

      return;
    }

    badgeEl.textContent = 'Dodatnih ' + additionalDiscountPct + '%';
    badgeEl.hidden = false;

    if (cardEl) {
      cardEl.classList.add('has-compared-discount');
    }
  }

  function updatePrice(sectionEl, priceValue, compareValue, badgeText) {
    var priceEl = sectionEl.querySelector('[data-opi-price-val]');
    var compareEl = sectionEl.querySelector('[data-opi-compare-val]');
    var badgeEl = sectionEl.querySelector('[data-opi-badge]');

    if (priceEl) {
      if (priceValue == null || priceValue === '') {
        var fallback =
          priceEl.getAttribute('data-price-cents') ||
          priceEl.dataset.basePrice ||
          priceEl.textContent.trim();
        priceEl.innerHTML = formatMoney(fallback);
      } else {
        priceEl.innerHTML = formatMoney(priceValue);
      }
    }

    var hasDiscount = compareValue && priceValue && compareValue > priceValue;

    if (compareEl) {
      if (hasDiscount) {
        compareEl.innerHTML = formatMoney(compareValue);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (badgeEl) {
      if (hasDiscount) {
        var pct = Math.round((compareValue - priceValue) * 100 / compareValue);
        badgeEl.textContent = badgeText || '-' + pct + '%';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
  }

  function formatMoney(value) {
    if (value == null || value === '') return '';

    var normalized = normalizeMoneyValue(value);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(normalized);
    }

    return (
      new Intl.NumberFormat('sr-RS', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(normalized / 100) + ' RSD'
    );
  }

  function isTruthySetting(value) {
    return value === true || value === 'true' || value === '1';
  }

  function isDiscounted(priceValue, compareValue) {
    return !!(compareValue && priceValue && compareValue > priceValue);
  }

  function isVariantDiscounted(variant, priceValue, compareValue) {
    if (variant) {
      return isDiscounted(
        normalizeMoneyValue(variant.price),
        variant.compareAtPrice != null ? normalizeMoneyValue(variant.compareAtPrice) : 0
      );
    }

    return isDiscounted(priceValue, compareValue);
  }

  function normalizeMfPrice(value) {
    var str = String(value).trim().replace(',', '.');
    var num = parseFloat(str);
    if (isNaN(num)) return 0;
    return Math.round(num * 100);
  }

  function normalizeMoneyValue(value) {
    if (typeof value === 'number') {
      return value < 1000 ? Math.round(value * 100) : Math.round(value);
    }

    var str = String(value).trim();
    if (!str) return 0;

    if (/^\d+[.,]\d{1,2}$/.test(str)) {
      return Math.round(parseFloat(str.replace(',', '.')) * 100);
    }

    str = str.replace(/[^\d]/g, '');
    return parseInt(str || '0', 10);
  }

  // ─────────────────────────────────────────────
  // FORM / ADD TO CART
  // ─────────────────────────────────────────────
  function initForm(sectionEl, state) {
    var form = sectionEl.querySelector('[data-opi-form]');
    var atcBtn = sectionEl.querySelector('[data-opi-atc]');
    var checkoutBtn = sectionEl.querySelector('[data-opi-checkout]');
    var errEl = sectionEl.querySelector('[data-opi-error]');
    if (!form || !atcBtn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitCart(sectionEl, state, atcBtn, errEl, false);
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        submitCart(sectionEl, state, checkoutBtn, errEl, true);
      });
    }
  }

  function submitCart(sectionEl, state, atcBtn, errEl, goToCheckout) {
    var form = sectionEl.querySelector('[data-opi-form]');
    if (form && form.hasAttribute('data-simple-atc')) {
      var variantId = parseInt(form.dataset.defaultVariant, 10);
      if (!variantId) return;
      hideError(errEl);
      setLoading(atcBtn, true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Greška.'); });
          return res.json();
        })
        .then(function () {
          setLoading(atcBtn, false);

          if (goToCheckout) {
            window.location.href = '/checkout';
            return;
          }

          openCartDrawer();
        })
        .catch(function (err) { setLoading(atcBtn, false); showError(errEl, err.message || 'Greška pri dodavanju u korpu.'); });
      return;
    }

    var errors = [];

    var pair1Id = state.pairs[1].variantId;
    if (!state.pairs[1].color) {
      errors.push('Par 1: izaberite boju.');
    } else if (!state.pairs[1].size) {
      errors.push('Par 1: izaberite veličinu.');
    } else if (!pair1Id) {
      errors.push('Par 1: izabrana kombinacija nije dostupna.');
    }

    var pair2Id = null;
    if (state.bundle === 2) {
      pair2Id = state.pairs[2].variantId;

      if (!state.pairs[2].color) {
        errors.push('Par 2: izaberite boju.');
      } else if (!state.pairs[2].size) {
        errors.push('Par 2: izaberite veličinu.');
      } else if (!pair2Id) {
        errors.push('Par 2: izabrana kombinacija nije dostupna.');
      }
    }

    if (errors.length) {
      showError(errEl, errors.join(' '));
      return;
    }

    hideError(errEl);
    setLoading(atcBtn, true);

    var items = [{ id: pair1Id, quantity: 1 }];
    if (state.bundle === 2 && pair2Id) {
      items.push({ id: pair2Id, quantity: 1 });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Greška pri dodavanju u korpu.');
          });
        }
        return res.json();
      })
      .then(function () {
        setLoading(atcBtn, false);
        openCartDrawer();
      })
      .catch(function (err) {
        setLoading(atcBtn, false);
        showError(errEl, err.message || 'Greška pri dodavanju u korpu. Pokušajte ponovo.');
      });
  }

  function setLoading(atcBtn, isLoading) {
    var textEl = atcBtn.querySelector('[data-atc-text]');
    var loadingEl = atcBtn.querySelector('[data-atc-loading]');

    atcBtn.disabled = isLoading;

    if (textEl) textEl.classList.toggle('is-hidden', isLoading);
    if (loadingEl) loadingEl.classList.toggle('is-hidden', !isLoading);
  }

  function showError(errEl, msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.classList.remove('is-hidden');
    errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideError(errEl) {
    if (!errEl) return;
    errEl.textContent = '';
    errEl.classList.add('is-hidden');
  }

  // ─────────────────────────────────────────────
  // CART DRAWER
  // ─────────────────────────────────────────────
  function openCartDrawer() {
    var drawerHost =
      document.querySelector('cart-drawer') ||
      (document.getElementById('CartDrawer') && document.getElementById('CartDrawer').closest('cart-drawer')) ||
      document.getElementById('CartDrawer');

    if (!drawerHost) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cartrefresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      return;
    }

    fetch('/?sections=cart-drawer')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) throw new Error('Cart drawer section not found.');

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer =
          parsed.querySelector('cart-drawer') ||
          (parsed.getElementById('CartDrawer') && parsed.getElementById('CartDrawer').closest('cart-drawer')) ||
          parsed.getElementById('CartDrawer');

        if (newDrawer && typeof drawerHost.renderContents === 'function') {
          drawerHost.renderContents({
            sections: {
              'cart-drawer': newDrawer.innerHTML
            }
          });
        } else if (newDrawer) {
          drawerHost.innerHTML = newDrawer.innerHTML;
        }

        if (typeof drawerHost.open === 'function') {
          drawerHost.open();
          return;
        }

        drawerHost.classList.add('active');
        document.body.classList.add('overflow-hidden');

        var inner = drawerHost.querySelector('.drawer__inner, .drawer__inner-empty, .drawerinner');
        if (inner) inner.focus();

        var overlay =
          document.getElementById('CartDrawer-Overlay') ||
          drawerHost.querySelector('.cart-drawer__overlay, .cart-draweroverlay, .drawer__overlay');

        if (overlay) overlay.classList.add('active');
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cartrefresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

        if (typeof drawerHost.open === 'function') {
          drawerHost.open();
          return;
        }

        drawerHost.classList.add('active');
        document.body.classList.add('overflow-hidden');
      });
  }

  // ─────────────────────────────────────────────
  // UPSELL
  // ─────────────────────────────────────────────
  function initUpsell(sectionEl) {
    var upsellEl = sectionEl.querySelector('[data-upsell]');
    if (!upsellEl) return;

    upsellEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;

      e.preventDefault();

      var variantId = parseInt(btn.dataset.upsellProductId, 10);
      if (!variantId) return;

      var originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Greška pri dodavanju upsell proizvoda.');
          return res.json();
        })
        .then(function () {
          btn.textContent = '✓';
          openCartDrawer();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  }

  // ─────────────────────────────────────────────
  // SIZE GUIDE
  // ─────────────────────────────────────────────
  function initSizeGuide(sectionEl) {
    var sidebar = document.getElementById('opi-size-guide');
    if (!sidebar) return;

    var overlay = sidebar.querySelector('[data-size-guide-overlay]');
    var closeBtn = sidebar.querySelector('[data-size-guide-close]');

    var rulerSVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12h20M2 12l4-4M2 12l4 4M22 12l-4-4M22 12l-4 4M7 12v3M12 12v5M17 12v3"/></svg>';

    sectionEl.querySelectorAll('[data-size-guide-trigger]').forEach(function (trigger) {
      if (!trigger.querySelector('svg')) {
        var iconSpan = document.createElement('span');
        iconSpan.className = 'opi-size-guide-trigger__icon';
        iconSpan.innerHTML = rulerSVG;
        iconSpan.setAttribute('aria-hidden', 'true');
        trigger.insertBefore(iconSpan, trigger.firstChild);
      }
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openSizeGuide();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closeSidebarFn);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeSidebarFn);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
        closeSidebarFn();
      }
    });

    function openSizeGuide() {
      sidebar.classList.add('is-open');
      document.body.classList.add('opi-overlay-open');
      if (closeBtn) closeBtn.focus();
    }

    function closeSidebarFn() {
      sidebar.classList.remove('is-open');
      document.body.classList.remove('opi-overlay-open');
    }
  }

  // ─────────────────────────────────────────────
  // ACCORDION
  // ─────────────────────────────────────────────
  function initAccordions(sectionEl) {
    var accordions = sectionEl.querySelectorAll('[data-accordion]');

    accordions.forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-accordion-trigger]');
      var body = accordion.querySelector('[data-accordion-body]');
      if (!trigger || !body) return;

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
        body.removeAttribute('hidden');
      });
    });
  }

  // ─────────────────────────────────────────────
  // BOOTSTRAP
  // ─────────────────────────────────────────────
  function bootstrap() {
    document.querySelectorAll('[data-ortomed-product-info]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ortomed-product-info]');
    if (section) {
      section.dataset.opiInitialized = 'false';
      init(section);
    }
  });
})();